import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Icon } from '@manychat/manyui'

import cm from './FancyBreadcrumbs.module.css'

export default class FancyBreadcrumbs extends React.Component {
  static propTypes = {
    currentStep: PropTypes.number.isRequired,
    titles: PropTypes.object.isRequired,
  }

  renderCircle = (title, index) => {
    const { currentStep } = this.props
    const passedOrCurrent = currentStep >= index
    const next = index > currentStep

    return (
      <React.Fragment key={index}>
        {index !== 0 && (
          <div
            className={cx(cm.connector, 'm-t flex-grow-1', {
              'bg-success': currentStep > index - 1,
            })}
          />
        )}
        <div className={'m-x-xxs d-flex p-relative'}>
          <div
            className={cx(
              cm.circle,
              { 'bg-success': passedOrCurrent, 'bg-secondary': next },
              'rounded-circle text-white text-subheading d-flex align-center justify-center m-b ',
            )}
          >
            {currentStep > index ? <Icon.Tick size={24} /> : index + 1}
          </div>
          <div
            className={cx('p-absolute text-center text-subheading', cm.title, {
              'text-success': passedOrCurrent,
              'text-secondary': next,
            })}
          >
            {title}
          </div>
        </div>
      </React.Fragment>
    )
  }

  render() {
    const { titles, className } = this.props

    return (
      <div className={cx('d-flex justify-between m-x-auto', className)}>
        {Object.keys(titles).map((key, i) => this.renderCircle(titles[key], i))}
      </div>
    )
  }
}
